import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreakPoint, Color, FontSize } from '../styles/constants';

const TextBox = styled.textarea`
  border: solid 1px ${Color.gray};
  border-radius: 4px;
  box-sizing: border-box;
  caret-color: ${Color.red};
  color: ${Color.text.darkGray};
  font-size: ${FontSize.medium};
  height: 96px;
  line-height: 1.6875;
  padding: 8px 16px;
  width: 100%;

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
  @media (min-width: ${BreakPoint.desktop}) {
    outline: none;
  }
`;

const TextArea = props => {
  const { ...options } = props;
  return <TextBox {...options} />;
};

TextArea.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

TextArea.defaultProps = {
  value: undefined,
  placeholder: undefined,
  onChange: () => {},
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/TextArea.jsx